<template>
  <div v-cloak>
    <div id="breadcrumb">
      <ol class="breadcrumb">
        <li class="active">
          <small>Store</small>
        </li>
        <li class="active">
          <small>Distributor Store</small>
        </li>
        <li class="active">
          <small>Store Central Mapping</small>
        </li>
      </ol>
    </div>
    <div class="tab">
      <el-tabs class="el-tabs" type="border-card">
        <el-tab-pane label="Detail">
          <d1-vue-component
            ref="basicComponent"
            :options="generateOption"
            data-facet-key="store_central_map"
            :d1CoreBaseUrl="baseD1Url"
            :ControlMoreSeachType="true"
            :MoreAndSearchClickView="false"
            @handleTableValueClick="handleTableValueClick"
            @onToolbarButtonClick="handleToolbarButtonClick"
            @getTableSelectedRows="getSelectedList"
          ></d1-vue-component>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- confirm弹窗 -->
    <el-dialog
      title="Confirm"
      :visible.sync="confirmShow"
      :close-on-click-modal="false"
      :center="true"
      width="400px"
      size="tiny"
    >
      <div class="dialog">Confirm to approve?</div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="handleData('confirm')"
          size="small"
          :loading="confirmLoading"
        >Confirm</el-button>
        <el-button
          type="info"
          @click="confirmShow = false;confirmLoading = false"
          size="small"
        >Cancel</el-button>
      </span>
    </el-dialog>

    <el-dialog
      width="550px"
      title="Reject"
      :visible.sync="rejectShow"
      :close-on-click-modal="false"
      :center="true"
      size="small"
    >
      <el-row :gutter="20" style="margin-bottom:20px">
        <el-col :span="6">
          <div class="text-right">
            <b style="color:red">*</b>Reject Reason:
          </div>
        </el-col>
        <el-col :span="18">
          <el-input
            type="textarea"
            v-model="reject_reason"
            placeholder="Please Input Reject Reason"
          ></el-input>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleData('reject')" size="small" :loading="rejectLoading">Reject</el-button>
        <el-button
          type="info"
          @click="rejectShow = false; reject_reason = '';"
          size="small"
        >Cancel</el-button>
      </span>
    </el-dialog>
    
    <div class="imgDialog" v-if="showImg">
      <div class="mask" @click.self="imgUrl=''">
        <el-image
          style="min-width:300px;max-width:500px;"
          :src="imgUrl"
          fit="contain"
          @error="loadImgErr"></el-image>
      </div>
    </div>
  </div>
</template>

<script>
import d1VueComponent from "@/components/d1/d1-vue-component";
import store from "@/store";
export default {
  components: {
    d1VueComponent
  },
  data() {
    return {
      generateOption: {
        queryUrl: "/dms/store-central-mapping/list?sort=gmt_modified,DESC",
        importUrl: "",
        exportUrl: "/dms/store-central-mapping/export-file?sort=gmt_modified,DESC",
        deleteUrl: "",
        modifyUrl: "",
        pageSize: 10,
        tableData: [{}],
        pageSettingData: {
          form: [{}],
          table: [{}]
        },
        showToolbarButtonList: true, //是否显示工具栏
        asyncExport: true,
        showExportButton: true,
        showTableSelection: true,
        showTableOperationButton: false,
        needMoreTableHead: true, //设置二级表头
        tableHeadConfig: {
          splitTime: 2, //分割两次
          splitIndex: 7, //分割线是2
          headNameList: ["SFA Store", "Unique Store"]
        },
        toolbarButtonList: [
          //Tabl左上键按钮组合
          {
            label: "Confirm ", //按钮显示的名称
            type: "success", //按钮的类型,默认空,支持  primary，success，info，warning，danger
            name: "confirm", // 用户点击时返回的组件
            elColWidth: 3 //按钮的占位
          },
          {
            label: "Reject ", //按钮显示的名称
            type: "danger", //按钮的类型,默认空,支持  primary，success，info，warning，danger
            name: "reject", // 用户点击时返回的组件
            elColWidth: 3 //按钮的占位
          }
        ],
        openform: true,
        tableCellDataLink: [
          {
            db_field_name: "store_seq", //需要增加a标签的字段名
            field_label: [""], //a标签显示的限制值
            dialogDisplaysValueFromFields: "", // 对话框的说明来源于字段
            needCustomProcess: true, //如果设置为ture
            name: ""
          },
          {
            db_field_name:"store_pic_name",  //需要增加a标签的字段名
            field_label: [""], //a标签显示的限制值
            dialogDisplaysValueFromFields: "", // 对话框的说明来源于字段
            needCustomProcess: true, //如果设置为ture
            name: ""
          },
          {
            db_field_name:"unique_store_pic_name",  //需要增加a标签的字段名
            field_label: [""], //a标签显示的限制值
            dialogDisplaysValueFromFields: "", // 对话框的说明来源于字段
            needCustomProcess: true, //如果设置为ture
            name: ""
          }
        ],
        showSelectColumn: false,
        pageTableType: "data_quality",
        ExchangeToolbarButtonPosition: true
      },
      selectRowIdList: [],
      confirmShow:false,
      rejectShow:false,
      reject_reason:'',
      rejectLoading:false,
      confirmLoading:false,
      imgUrl:''
    };
  },
  watch: {},
  computed: {
    // isSuper() {
    //   console.log(store);
    //   if (store.getters.getSuperRoles.includes(store.getters.getRole)) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    showImg(){
      return this.imgUrl?true:false
    }
  },
  created() {},
  mounted() {},
  methods: {
    handleClose(){
      this.imgUrl = ''
    },
    handleTableValueClick(row, dbFieldName) {
      if (dbFieldName === "store_seq") {
      //  跳转之前先调用接口拿到数据
        let url = this.baseStoreUrl + '/dms/store-banner-mapping/getDetailValue'
        let arr = [
          {store_seqs:row.store_seq}
        ]
        this.http.post(url,arr).then(res=>{
          if(res.data[0].store_id){
            let routeData = this.$router.resolve({
              path: "/store-detail",
              query: {
                id: res.data[0].store_id,
                storeSeq:row.store_seq,
                name: "Store Central Mapping",
                dmsId: row.dms_id,
                dmsStoreId: row.dms_store_id,
                subId: row.sub_id,
                status: row.mapping_status
              }
            });
            window.open(routeData.href, '_blank')
          }else {
            // this.$message.error('获取Store Id失败')
            // 没有ID的时候也要打开详情页，所以这个时候随便传一个不存在的id就行
            this.$router.push({
              path: "/store-detail",
              query: {
                id: 'aaa',
                storeSeq:row.store_seq,
                name: "Store Central Mapping",
                dmsId: row.dms_id,
                dmsStoreId: row.dms_store_id,
                subId: row.sub_id,
                status: row.mapping_status
              }
            });
          }
        }).catch(err=>{
          this.$message.error('获取Store Id失败')
        }) 

      } else if (dbFieldName === "store_pic_name") {
        if(row.source_picture){
          this.imgUrl = row.source_picture
        }else {
          this.$message.warning('暂无图片')
        }
      }else if(dbFieldName === "unique_store_pic_name"){
        if(row.matched_store_picture){
          this.imgUrl = row.matched_store_picture
        }else {
          this.$message.warning('暂无图片')
        }
      }
    },
    // 表格上方按钮组点击事件
    handleToolbarButtonClick(name) {
      if (this.selectRowIdList.length == 0) {
        this.$message.warning("Please select records");
        return;
      }
      if (this.selectRowIdList.length > 10) {
        this.$message.warning("Please select records less than 10 to process");
        return;
      }
      //confirm和reject都只能是待审批的，多选的时候包含多种情况的话就return 
      if (name == "confirm") {
        if(this.validateList()){
          this.confirmShow = true
        }else {
          this.$message.error("只能选择待审批状态的数据");
          return
        }
      } else if (name == "reject") {
        if(this.validateList()){
          this.rejectShow = true
        }else {
          this.$message.error("只能选择待审批状态的数据");
          return
        }
      }
    },
    getSelectedList(rowList) {
      this.selectRowIdList = [];
      rowList.map(item => {
        this.selectRowIdList.push({
          dmsId:item.dms_id,
          dmsStoreId:item.dms_store_id,
          subId:item.sub_id,
          store_seq:item.store_seq,
          mapping_status:item.mapping_status
        });
      });
    },
    validateList(){
      let arr = []
      this.selectRowIdList.map(item=>{
        if(item.mapping_status!='待审批'){
          arr.push(item)
        }
      })
      console.log(arr)
      if(arr.length>0){
        return false
      }else {
        return true
      }
    },
    handleData(type){
      let dmsIdList = []
      let dmsStoreIdList = []
      let subIdList = []
      let storeSeqList = []
      this.selectRowIdList.map(item=>{
        dmsIdList.push(item.dmsId)
        dmsStoreIdList.push(item.dmsStoreId)
        subIdList.push(item.subId)
        storeSeqList.push(item.store_seq)
      })
      let tips=''
      let obj = {}
      if(type=='confirm'){
        obj.operation = 'approve'
        this.confirmLoading = true
        tips = 'Confirm Success'
      }
      if(type=='reject'){
        if(!this.reject_reason){
          this.$message.error('请填写原因')
          return
        }else {
          obj.operation = 'reject'
          obj.comment = this.reject_reason
          this.rejectLoading = true
          tips = 'Reject Success'
        }
      }      
      // obj.dmsid = dmsIdList
      // obj.dmsstoreid = dmsStoreIdList
      // obj.subid = subIdList
      obj.store_seq = storeSeqList
    
      let url = this.baseStoreUrl + '/dms/store-central-mapping/approval'
      this.http.post(url,obj).then(res=>{
        // console.log(res,'ppppppppppppp===========')
        this.$message.success(tips)
        this.confirmLoading = false
        this.rejectLoading = false
        this.confirmShow = false
        this.rejectShow = false
        this.selectRowIdList = []
        this.$refs.basicComponent.runQuery();
      }).catch(err=>{
        this.confirmLoading = false
        this.rejectLoading = false
      })
    },
    loadImgErr(){
      this.imgUrl = ''
      this.$message.error('图片加载失败')
    }
  }
};
</script>

<style lang="scss" scoped>
[v-cloak] {
  display: none;
}
.breadcrumb {
  background-color: transparent !important;
  margin-bottom: 0px;
}
.imgDialog {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  background: rgba(0,0,0,0.3);
  z-index: 3000;
  .mask {
      margin-top: 15vh;
      text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/store/store_central/store_central_mapping.vue